import Typography from '@mui/material/Typography'
import { FundingWalletProgram } from '../../types'
import { formatAmount } from '../../utils/format'
import { fundingColors as C } from '../../theme/figmaColors'
import { useStyles } from './WalletBar.styles'

export const currencySymbol = (currency: string) =>
  currency === 'USD' ? '$' : currency

interface SeriesItem {
  key: string
  label: string
  color: string
  value: number
  inBar: boolean
}

export const buildSeries = (p: FundingWalletProgram): SeriesItem[] => [
  {
    key: 'total',
    label: 'Total',
    color: C.seriesTotal,
    value: p.total,
    inBar: false,
  },
  {
    key: 'consumed',
    label: 'Consumed',
    color: C.seriesConsumed,
    value: p.consumed,
    inBar: true,
  },
  {
    key: 'available',
    label: 'Available',
    color: C.seriesAvailable,
    value: p.available,
    inBar: true,
  },
  {
    key: 'extra',
    label: 'Extra required',
    color: C.seriesExtra,
    value: p.extraRequired,
    inBar: true,
  },
]

export const WalletBar = ({ program }: { program: FundingWalletProgram }) => {
  const { classes } = useStyles()
  const symbol = currencySymbol(program.currency)
  const series = buildSeries(program)
  const barItems = series.filter(s => s.inBar)
  const barTotal = barItems.reduce((sum, s) => sum + Math.max(s.value, 0), 0)

  return (
    <div className={classes.barLegend}>
      <div className={classes.bar}>
        {barItems.map(s => {
          const pct = barTotal > 0 ? (Math.max(s.value, 0) / barTotal) * 100 : 0
          if (pct === 0) return null
          return (
            <span
              key={s.key}
              className={classes.barSegment}
              style={{ width: `${pct}%`, backgroundColor: s.color }}
            />
          )
        })}
      </div>

      <div className={classes.legend}>
        {series.map(s => (
          <div key={s.key} className={classes.legendItem}>
            <div className={classes.legendLabelRow}>
              <span
                className={classes.dot}
                style={{ backgroundColor: s.color }}
              />
              <Typography className={classes.legendLabel}>{s.label}</Typography>
            </div>
            <Typography component="div" className={classes.legendValue}>
              <Typography component="span" className={classes.legendCurrency}>
                {symbol}
              </Typography>
              <Typography component="span" className={classes.legendNumber}>
                {formatAmount(s.value)}
              </Typography>
            </Typography>
          </div>
        ))}
      </div>
    </div>
  )
}
